import { FilterType } from '@/models/filter/FilterType';
import { RECOMMENDATIONS_SECTION_ID, SectionId } from '../types/filterDraft.types';
import { FILTER_SECTIONS } from '../filters.config';

const FILTERABLE_SECTION_IDS: SectionId[] = FILTER_SECTIONS.filter(
  section => !section.disabled && section.id !== RECOMMENDATIONS_SECTION_ID,
).map(section => section.id);

const SECTION_KEYS_MAP = FILTER_SECTIONS.reduce<Record<string, FilterType[]>>((acc, section) => {
  acc[section.id] = section.filterKeys.flatMap((key): FilterType[] => (Array.isArray(key) ? key : [key]));
  return acc;
}, {});

const FILTER_TO_SECTION_MAP = FILTERABLE_SECTION_IDS.reduce<Partial<Record<FilterType, SectionId>>>(
  (acc, sectionId) => {
    const keys = SECTION_KEYS_MAP[sectionId] ?? [];
    keys.forEach(key => {
      acc[key] = sectionId;
    });
    return acc;
  },
  {},
);

export const getFilterSectionId = (filterKey: FilterType | FilterType[]): SectionId | null => {
  const flattenedKey = Array.isArray(filterKey) ? filterKey[0] : filterKey;
  return FILTER_TO_SECTION_MAP[flattenedKey] ?? null;
};

export const getFilterableSectionIds = (): SectionId[] => {
  return FILTERABLE_SECTION_IDS;
};

export const getFilterKeysForSection = (sectionId: SectionId): FilterType[] => {
  return SECTION_KEYS_MAP[sectionId] ?? [];
};

export const createFilterToSectionMap = (): Partial<Record<FilterType, SectionId>> => {
  return { ...FILTER_TO_SECTION_MAP };
};
